import '.././pages.css';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import FilterPanel from '../../components/Filters/FilterPanel';
import QuarantineTestsTable from '../../components/QuarantineTestsTable/QuarantineTestsTable';
import PlatformBreakdownChart from '../../components/Cards/PlatformBreakdownChart';
import UnitBreakdownChart from '../../components/Cards/UnitBreakdownChart';
import QuarantineChart from '../../components/Cards/QuarantineChart';

const availablePlatforms = [
  "All platforms",
  "@sdk/android",
  "@sdk/ios",
  "@sdk/flutter-android",
  "@sdk/flutter-ios",
  "@sdk/react-native-android",
  "@sdk/react-native-ios",
];

const filterFields = [
  {
    key: 'platform',
    label: 'Platform',
    options: availablePlatforms,
    defaultValue: 'All platforms',
  },
  {
    key: 'unit',
    label: 'Unit',
    options: ['All units', 'error_and_surveys', 'screen_insights', 'session_replay'],
    defaultValue: 'All units',
  },
];

function Filters({ selectedPlatform, selectedUnit, onFilterApply }) {
  return (
    <div className="filters-container" style={{ display: 'flex', alignItems: 'center' }}>
      <FilterPanel
        fields={filterFields}
        values={{ platform: selectedPlatform, unit: selectedUnit }}
        onApply={onFilterApply}
      />
    </div>
  );
}

function TestsQuarantine() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(() => ({
    selectedPlatform: searchParams.get('platform') || 'All platforms',
    selectedUnit: searchParams.get('unit') || 'All units',
  }));

  useEffect(() => {
    const platform = searchParams.get('platform') || 'All platforms';
    const unit = searchParams.get('unit') || 'All units';
    setFilters(prev => {
      if (prev.selectedPlatform === platform && prev.selectedUnit === unit) {
        return prev;
      }
      return {
        selectedPlatform: platform,
        selectedUnit: unit,
      };
    });
  }, [searchParams]);

  const location = useLocation();
  const handleFilterApply = ({ platform, unit }) => {
    setFilters(prev => ({ ...prev, selectedPlatform: platform, selectedUnit: unit }));
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      if (platform && platform !== 'All platforms') {
        next.set('platform', platform);
      } else {
        next.delete('platform');
      }
      if (unit && unit !== 'All units') {
        next.set('unit', unit);
      } else {
        next.delete('unit');
      }
      return next;
    }, { replace: true });
  };

  return (
    <div className="application-container">
      {location.pathname === '/mobile/tests-quarantine' && (
        <>
          <Filters
            selectedPlatform={filters.selectedPlatform}
            selectedUnit={filters.selectedUnit}
            onFilterApply={handleFilterApply}
          />
          <div className="flex-container">
            <div className="cards-container">
              <PlatformBreakdownChart selectedUnit={filters.selectedUnit}/>
              <UnitBreakdownChart selectedPlatform={filters.selectedPlatform}/>
              <QuarantineChart selectedUnit={filters.selectedUnit}/>
            </div>
          </div>
          <QuarantineTestsTable
            selectedPlatform={filters.selectedPlatform}
            selectedUnit={filters.selectedUnit}
          />
        </>
      )}
    </div>
  );
}

export default TestsQuarantine; 